// Real footage stills for the demo scenes — one coherent fictional documentary
// project ("Horizon docu") so the same clips recur across scenes the way a real
// library would. Sources are generated stills processed by
// design-reference/process-stills.py (crops remove letterboxes/subtitles).
import drone from '../assets/stills/drone.jpg';
import coast from '../assets/stills/coast.jpg';
import rooftop from '../assets/stills/rooftop.jpg';
import townhall from '../assets/stills/townhall.jpg';
import podium from '../assets/stills/podium.jpg';
import walking from '../assets/stills/walking.jpg';
import hosts from '../assets/stills/hosts.jpg';
import hostsSarah from '../assets/stills/hosts-sarah.jpg';
import hostsMarcus from '../assets/stills/hosts-marcus.jpg';
import interview from '../assets/stills/interview.jpg';
import bts from '../assets/stills/bts.jpg';
import citydusk from '../assets/stills/citydusk.jpg';
import crowd from '../assets/stills/crowd.jpg';
import aerial2 from '../assets/stills/aerial2.jpg';
import aerial3 from '../assets/stills/aerial3.jpg';
import headland from '../assets/stills/headland.jpg';
import rooftopBts from '../assets/stills/rooftopbts.jpg';
import podiumWide from '../assets/stills/podiumwide.jpg';
import podiumSide from '../assets/stills/podiumside.jpg';
import rooftopRev from '../assets/stills/rooftoprev.jpg';
import walking2 from '../assets/stills/walking2.jpg';
import estuary from '../assets/stills/estuary.jpg';
import seastacks from '../assets/stills/seastacks.jpg';
import surf from '../assets/stills/surf.jpg';
import harbor from '../assets/stills/harbor.jpg';

import faceNadiaA from '../assets/stills/face-nadia-a.jpg';
import faceNadiaB from '../assets/stills/face-nadia-b.jpg';
import faceSarahA from '../assets/stills/face-sarah-a.jpg';
import faceSarahB from '../assets/stills/face-sarah-b.jpg';
import faceMarcusA from '../assets/stills/face-marcus-a.jpg';
import faceMarcusB from '../assets/stills/face-marcus-b.jpg';
import faceU1A from '../assets/stills/face-u1-a.jpg';
import faceU1B from '../assets/stills/face-u1-b.jpg';
import faceU2A from '../assets/stills/face-u2-a.jpg';
import faceU2B from '../assets/stills/face-u2-b.jpg';
import faceU3A from '../assets/stills/face-u3-a.jpg';
import faceU3B from '../assets/stills/face-u3-b.jpg';
import faceU4A from '../assets/stills/face-u4-a.jpg';
import faceU4B from '../assets/stills/face-u4-b.jpg';
import faceU5A from '../assets/stills/face-u5-a.jpg';
import faceU5B from '../assets/stills/face-u5-b.jpg';
import faceRoofA from '../assets/stills/face-roofman-a.jpg';
import faceRoofB from '../assets/stills/face-roofman-b.jpg';
import faceExecA from '../assets/stills/face-exec-a.jpg';
import faceExecB from '../assets/stills/face-exec-b.jpg';

// Archival set — the app's real demo library (NASA / National Archives /
// Prelinger, all PD-safe), processed by design-reference/process-archival.py.
// FULL archival re-skin direction: founder, 2026-07-17.
import launchpad from '../assets/stills/arch-launchpad.jpg';
import ignition from '../assets/stills/arch-ignition.jpg';
import liftoff from '../assets/stills/arch-liftoff.jpg';
import flagplant from '../assets/stills/arch-flagplant.jpg';
import moonwalkers from '../assets/stills/arch-moonwalkers.jpg';
import moonflag from '../assets/stills/arch-moonflag.jpg';
import moonsurface from '../assets/stills/arch-moonsurface.jpg';
import ricespeech from '../assets/stills/arch-ricespeech.jpg';
import ricehands from '../assets/stills/arch-ricehands.jpg';
import inauguration from '../assets/stills/arch-inauguration.jpg';
import cubaaddress from '../assets/stills/arch-cubaaddress.jpg';
import astronautsdesk from '../assets/stills/arch-astronautsdesk.jpg';
import freeway from '../assets/stills/arch-freeway.jpg';
import freewaycars from '../assets/stills/arch-freewaycars.jpg';
import factory from '../assets/stills/arch-factory.jpg';
import office from '../assets/stills/arch-office.jpg';
import classroom from '../assets/stills/arch-classroom.jpg';
import beachchimps from '../assets/stills/arch-beachchimps.jpg';

// wave 2 — the remaining mockups go archival (2026-07-17)
import moonwalk2 from '../assets/stills/arch-moonwalk2.jpg';
import padflame from '../assets/stills/arch-padflame.jpg';
import padsmoke from '../assets/stills/arch-padsmoke.jpg';
import climb from '../assets/stills/arch-climb.jpg';
import tracking from '../assets/stills/arch-tracking.jpg';
import oath from '../assets/stills/arch-oath.jpg';
import oath2 from '../assets/stills/arch-oath2.jpg';
import handshake from '../assets/stills/arch-handshake.jpg';
import capitolcrowd from '../assets/stills/arch-capitolcrowd.jpg';
import paradecrowd from '../assets/stills/arch-paradecrowd.jpg';
import paradestands from '../assets/stills/arch-paradestands.jpg';
import motorcade from '../assets/stills/arch-motorcade.jpg';
import escort from '../assets/stills/arch-escort.jpg';
import freeway3 from '../assets/stills/arch-freeway3.jpg';
import underpass from '../assets/stills/arch-underpass.jpg';
import beachcrowd from '../assets/stills/arch-beachcrowd.jpg';
import classwide from '../assets/stills/arch-classwide.jpg';
import pressdesk2 from '../assets/stills/arch-pressdesk2.jpg';
import pressdesk3 from '../assets/stills/arch-pressdesk3.jpg';

// archival wave 3 — footage expansion (only the wired ones are imported; the rest live unimported in assets/)
import cubashop from '../assets/stills/arch-cubashop.jpg';
import cubasalon from '../assets/stills/arch-cubasalon.jpg';
import redstoneliftoff from '../assets/stills/arch-redstoneliftoff.jpg';

import faceJfkA from '../assets/stills/face-jfk-a.jpg';
import faceJfkB from '../assets/stills/face-jfk-b.jpg';
import faceJfk2A from '../assets/stills/face-jfk2-a.jpg';
import faceJfk2B from '../assets/stills/face-jfk2-b.jpg';
import faceArmstrongA from '../assets/stills/face-armstrong-a.jpg';
import faceArmstrongB from '../assets/stills/face-armstrong-b.jpg';
import faceAldrinA from '../assets/stills/face-aldrin-a.jpg';
import faceAldrinB from '../assets/stills/face-aldrin-b.jpg';
import faceCollinsA from '../assets/stills/face-collins-a.jpg';
import faceCollinsB from '../assets/stills/face-collins-b.jpg';

export const STILLS = {
  drone, coast, rooftop, townhall, podium, walking,
  hosts, hostsSarah, hostsMarcus, interview, bts, citydusk, crowd,
  aerial2, aerial3, headland, rooftopBts, podiumWide, podiumSide, rooftopRev, walking2,
  estuary, seastacks, surf, harbor,
  // archival
  launchpad, ignition, liftoff, flagplant, moonwalkers, moonflag, moonsurface,
  ricespeech, ricehands, inauguration, cubaaddress, astronautsdesk,
  freeway, freewaycars, factory, office, classroom, beachchimps,
  // archival wave 2
  moonwalk2, padflame, padsmoke, climb, tracking,
  oath, oath2, handshake, capitolcrowd, paradecrowd, paradestands, motorcade, escort,
  freeway3, underpass, beachcrowd, classwide, pressdesk2, pressdesk3,
  // archival wave 3 — footage expansion (only the wired ones are imported; the rest live unimported in assets/)
  cubashop, cubasalon, redstoneliftoff,
};

// [tight crop, wider crop] per person — face cards show two crops like the real app
export const FACES = {
  nadia: [faceNadiaA, faceNadiaB],
  sarah: [faceSarahA, faceSarahB],
  marcus: [faceMarcusA, faceMarcusB],
  u1: [faceU1A, faceU1B],
  u2: [faceU2A, faceU2B],
  u3: [faceU3A, faceU3B],
  u4: [faceU4A, faceU4B],
  u5: [faceU5A, faceU5B],
  roofman: [faceRoofA, faceRoofB],
  exec: [faceExecA, faceExecB],
  // archival — public figures only, never named private individuals
  jfk: [faceJfkA, faceJfkB],
  jfk2: [faceJfk2A, faceJfk2B],
  armstrong: [faceArmstrongA, faceArmstrongB],
  aldrin: [faceAldrinA, faceAldrinB],
  collins: [faceCollinsA, faceCollinsB],
} as const;
